import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../redux/features/authSlice"; // Adjust the path to your auth state
import { usePropertyStore } from "../../redux/features/propertyDetailSlice"; // Adjust the path to your auth state

export const PrivateRouteAfterLogin = ({ element }) => {
  const { loginInfo, isLoggedin } = useAuthStore();
  const isAuthenticated = !!loginInfo?.user; // Check if user exists

  return isAuthenticated ? element : <Navigate to="/" replace />;
};

export const PrivateRoutePropertyData = ({ element }) => {
  const { propertyInfo } = usePropertyStore();

  const isPropertyInfoExists =
    propertyInfo?.location && Object.keys(propertyInfo.location).length > 0;

  return isPropertyInfoExists ? element : <Navigate to="/" replace />;
}
